import { AccountSettingsField } from "@/common/enums/accountSettings";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useDeleteUser } from "@/hooks/user/useDeleteUser";
import { useMultiModalController } from "@/store/multiModalController.store";
import { t } from "i18next";

export const DeleteAccountDialog = (): JSX.Element => {
  const { modals, setOpenByModalId } = useMultiModalController();

  const { deleteUser, loading } = useDeleteUser();

  const handleDelete = (): void => {
    void deleteUser();
    setOpenByModalId(AccountSettingsField.DELETE_ACCOUNT, false);
  };

  return (
    <Dialog
      open={modals[AccountSettingsField.DELETE_ACCOUNT]}
      onOpenChange={(open) => {
        setOpenByModalId(AccountSettingsField.DELETE_ACCOUNT, open);
      }}
    >
      <DialogContent>
        <DialogHeader className="space-y-4">
          <DialogTitle className="text-center">
            {t("settings.account.deleteAccount.title")}
          </DialogTitle>
          <DialogDescription>
            {t("settings.account.deleteAccount.deleteCTA")}
          </DialogDescription>
        </DialogHeader>
        <Button
          disabled={loading}
          variant={"destructive"}
          onClick={handleDelete}
        >
          {t("settings.account.deleteAccount.confirmButton")}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
